import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../pages/SettingsPage';
import { ProtectedRoute } from '../../../shared/ui';

const ProtectedSettings = () => (
  <ProtectedRoute>
    <SettingsPage />
  </ProtectedRoute>
);

export const Route = createFileRoute('/settings')({
  component: ProtectedSettings,
});
